import type { ComponentTheme } from '../types/component-theme';

import { dataCollectionFooterInfoStyles } from '../shared-styles';

export default {
    slots: {
        root: 'flex h-full min-h-0 flex-col',
        header: 'mb-8 flex flex-col gap-x-6 gap-y-4 md:flex-row md:items-center',
        titleRow: 'flex min-w-0 items-center gap-3',
        titleWrap: 'flex grow-0 flex-col gap-y-2 lg:gap-y-3',
        title: 'text-3xl font-semibold text-black',
        description: 'text-base font-medium text-gray-500',
        actions: 'flex shrink-0',
        searchWrap: 'grow-0 shrink-0 md:ml-auto md:basis-85.5 lg:basis-108.75',
        searchInput: 'h-14 w-full text-base font-semibold placeholder:font-semibold',
        searchIcon: 'text-gray-400',
        body: 'min-h-0 flex-1 overflow-hidden',
        scroll: 'h-full overflow-y-auto scrollbar-gutter-stable',
        items: 'flex flex-col gap-5 px-2 py-2',
        empty: 'py-10',
        emptyText: 'text-center text-sm text-gray-500',
        footer:
            'grid shrink-0 min-w-0 items-center border-t-[0.063rem] border-t-(--neutral-border-soft) bg-transparent ' +
            'px-0! py-4! text-[0.85rem] text-gray-500 sm:px-6!',
        footerInfo: dataCollectionFooterInfoStyles,
        footerPagination: 'flex min-w-0 justify-center pt-4'
    },
    variants: {
        sidebarOpen: {
            true: {
                footer: 'wide:grid-cols-2',
                footerInfo: 'wide:text-start',
                footerPagination: 'wide:justify-end wide:pt-0'
            },
            false: {
                footer: 'desk:grid-cols-2',
                footerInfo: 'desk:text-start',
                footerPagination: 'desk:justify-end desk:pt-0'
            }
        }
    }
} satisfies ComponentTheme;
